import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from "rxjs";
import { Utilities } from 'src/app/services/utilities';

@Injectable({ providedIn: 'root' })
export class NavigationStateProviderService {

    routingParams$ = new BehaviorSubject<Map<string, string>>(new Map<string, string>());
    constructor(private router: Router, private route: ActivatedRoute) {
    }

    registerParams(params: Map<string, string>) {
        this.routingParams$.next(params);
        console.log('SMART ACTION PARAMETERS REGISTERED => ', params);
    }

    getSmartActionParams() {
        return this.routingParams$.getValue();
    }

    clearQueryParams() {
        const actionParams = this.getSmartActionParams();
        if (actionParams.size === 0) return;

        actionParams.forEach((value, key, map) => {
            map[key] = undefined;
        });

        const target = Utilities.routeLastChild(this.route);
        this.router.navigate(['./'], { relativeTo: target, queryParams: actionParams, queryParamsHandling: 'merge' });
    }
}